import React, { useCallback } from 'react';
import { type LinkComponent } from '@atlassian/search-dialog/search-link-component';
import { FormattedMessage } from 'react-intl-next';

import { MoreFiltersLink } from './more-filters.styled';
import { getTrigger } from '../../analytics/utils';
import { useAnalytics } from '../../analytics/use-analytics';
import { onMoreFiltersSelected, type Trigger } from '../../analytics/events';
import { messages } from '../../../messages';

export interface MoreFiltersProps {
	isLoading: boolean;
	linkComponent?: LinkComponent;
	query: string;
	href: string;
	selectedFiltersCount: number;
	onClick?: () => void;
}

const MoreFilters: React.FunctionComponent<MoreFiltersProps> = ({
	linkComponent,
	href,
	selectedFiltersCount,
	isLoading,
	onClick,
	...rest
}) => {
	const { fireAnalyticsEvent } = useAnalytics();

	const onMoreFiltersClicked = useCallback(
		(event: React.MouseEvent<any, MouseEvent>) => {
			const trigger: Trigger = getTrigger(event);
			onClick?.();
			fireAnalyticsEvent(
				onMoreFiltersSelected({
					trigger,
					selectedFiltersCount,
				}),
			);
		},
		[fireAnalyticsEvent, selectedFiltersCount, onClick],
	);

	if (isLoading) {
		return null;
	}

	return (
		<MoreFiltersLink
			{...rest}
			linkComponent={linkComponent}
			href={href}
			onClick={onMoreFiltersClicked}
		>
			<FormattedMessage {...messages.more_filters} />
		</MoreFiltersLink>
	);
};

export default MoreFilters;
